import { render, staticRenderFns } from "./FirstPredictionCard.vue?vue&type=template&id=353f7252&scoped=true"
import script from "./FirstPredictionCard.vue?vue&type=script&lang=js"
export * from "./FirstPredictionCard.vue?vue&type=script&lang=js"
import style0 from "./FirstPredictionCard.vue?vue&type=style&index=0&id=353f7252&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353f7252",
  null
  
)

export default component.exports